// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailsSection-module--container--TS9CN","organisation":"DetailsSection-module--organisation--3IYBz"};